import { Component, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from "../../services/toast.service";

@Component({
    selector: 'app-toasts',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    host: { '[class.ngb-toasts]': 'true' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {
  }

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
